import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ScanFace, ChevronRight } from "lucide-react";

export const FaceEnrolmentNudge = () => {
  const { user } = useAuth();
  const isAdmin = ["founder", "admin"].includes(user?.role);
  const { data = [] } = useQuery({
    queryKey: ["face-list"],
    queryFn: async () => (await api.get("/face/admin/list")).data,
    enabled: isAdmin,
  });
  if (!isAdmin) return null;
  const pending = data.filter((f) => !f.registered);
  if (pending.length === 0) return null;
  const names = pending.map((p) => p.name).join(", ");
  return (
    <Link
      to="/attendance"
      data-testid="face-enrolment-nudge"
      className="mb-6 flex items-center gap-4 rounded-lg border border-gold/40 bg-gold/10 p-4 transition-colors hover:bg-gold/20"
    >
      <div className="rounded-lg bg-navy/10 p-2.5"><ScanFace className="h-6 w-6 text-navy" /></div>
      <div className="min-w-0 flex-1">
        <p className="font-heading text-sm font-semibold text-navy">
          {pending.length} team member{pending.length > 1 ? "s" : ""} haven't set up Face ID
        </p>
        <p className="truncate text-xs text-slate-600">{names} · they can't punch in until they register</p>
      </div>
      <ChevronRight className="h-5 w-5 shrink-0 text-navy/60" />
    </Link>
  );
};
